export default "__VITE_ASSET__366fba28__"